require('./bootstrap');

let mqLG = window.matchMedia( "(min-width: 1024px)" );

let selectorFiltros = document.querySelector(".selector-filtros");
let desplegables = selectorFiltros.getElementsByClassName("deslegable");

selectorFiltros.addEventListener("click", (e) => {
    if(!mqLG.matches && e.target && e.target.tagName === "DIV" && e.target.classList.contains('btn')) {
        e.preventDefault();

        for (let desplegable of desplegables) {
            if (e.target.nextElementSibling === desplegable) {
                desplegable.classList.toggle("abierto");
            } else {
                desplegable.classList.remove("abierto");
            }
        }
    }
})

window.addEventListener('resize', (e) => {
    if (mqLG.matches) {
        for (let desplegable of desplegables) {
            desplegable.classList.remove("abierto");
        }
    }
});
